import * as React from 'react';
import React__default from 'react';
import classNames from 'classnames';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _excluded$7 = ["children", "className", "currentPage", "lastPage", "aria-labelledby", "aria-label"];
var PaginationContext = /*#__PURE__*/React.createContext({
  currentPage: 0,
  lastPage: 0
});
var usePagination = function usePagination() {
  return React.useContext(PaginationContext);
};
var PaginationContainer = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      currentPage = _ref.currentPage,
      lastPage = _ref.lastPage,
      _ref$ariaLabelledby = _ref['aria-labelledby'],
      ariaLabelledBy = _ref$ariaLabelledby === void 0 ? 'pagination-heading' : _ref$ariaLabelledby,
      _ref$ariaLabel = _ref['aria-label'],
      ariaLabel = _ref$ariaLabel === void 0 ? 'Resultatsider' : _ref$ariaLabel,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$7);

  if (!Number.isInteger(currentPage)) {
    throw new TypeError("Invalid currentPage: " + JSON.stringify(currentPage));
  }

  if (!Number.isInteger(lastPage)) {
    throw new TypeError("Invalid lastPage: " + JSON.stringify(lastPage));
  }

  var context = React.useMemo(function () {
    return {
      currentPage: Math.max(1, Math.min(currentPage, lastPage)),
      lastPage: Math.max(1, lastPage)
    };
  }, [currentPage, lastPage]);
  return /*#__PURE__*/React.createElement("nav", _extends({}, props, {
    className: classNames('flex items-center justify-center', className),
    "aria-labelledby": ariaLabelledBy,
    ref: ref
  }), /*#__PURE__*/React.createElement("h1", {
    className: "sr-only",
    id: ariaLabelledBy
  }, ariaLabel), /*#__PURE__*/React.createElement(PaginationContext.Provider, {
    value: context
  }, children));
});
PaginationContainer.displayName = "PaginationContainer";

var _excluded$6 = ["children", "className"];
var CurrentPage = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$6);

  var _usePagination = usePagination(),
      currentPage = _usePagination.currentPage;

  if (currentPage <= 1) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: classNames('block md:hidden p-8', className),
    ref: ref
  }), children || "Side " + currentPage);
});
CurrentPage.displayName = "CurrentPage";

var IconChevronDoubleLeft16 = function IconChevronDoubleLeft16(attrs) {
  return /*#__PURE__*/React__default.createElement('svg', Object.assign({
    xmlns: 'http://www.w3.org/2000/svg',
    width: '16',
    height: '16',
    fill: 'none',
    viewBox: '0 0 16 16',
    dangerouslySetInnerHTML: {
      __html: '<path fill="currentColor" d="M14.53 3.53a.75.75 0 00-1.06-1.06l-5 5a.75.75 0 000 1.06l5 5a.75.75 0 101.06-1.06L10.06 8l4.47-4.47zM7.53 3.53a.75.75 0 00-1.06-1.06l-5 5a.75.75 0 000 1.06l5 5a.75.75 0 001.06-1.06L3.06 8l4.47-4.47z"></path>'
    }
  }, attrs));
};

var IconChevronLeft16 = function IconChevronLeft16(attrs) {
  return /*#__PURE__*/React__default.createElement('svg', Object.assign({
    xmlns: 'http://www.w3.org/2000/svg',
    width: '16',
    height: '16',
    fill: 'none',
    viewBox: '0 0 16 16',
    dangerouslySetInnerHTML: {
      __html: '<path fill="currentColor" fill-rule="evenodd" d="M11.28 2.22a.75.75 0 010 1.06L6.31 8.25l4.97 4.97a.75.75 0 11-1.06 1.06l-5.5-5.5a.75.75 0 010-1.06l5.5-5.5a.75.75 0 011.06 0z" clip-rule="evenodd"></path>'
    }
  }, attrs));
};

var IconChevronRight16 = function IconChevronRight16(attrs) {
  return /*#__PURE__*/React__default.createElement('svg', Object.assign({
    xmlns: 'http://www.w3.org/2000/svg',
    width: '16',
    height: '16',
    fill: 'none',
    viewBox: '0 0 16 16',
    dangerouslySetInnerHTML: {
      __html: '<path fill="currentColor" fill-rule="evenodd" d="M4.22 2.22a.75.75 0 011.06 0l5.5 5.5a.75.75 0 010 1.06l-5.5 5.5a.75.75 0 01-1.06-1.06l4.97-4.97-4.97-4.97a.75.75 0 010-1.06z" clip-rule="evenodd"></path>'
    }
  }, attrs));
};

var _IconChevronDoubleLef;

var _excluded$5 = ["className"];
var FirstPage = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$5);

  var _usePagination = usePagination(),
      currentPage = _usePagination.currentPage;

  if (currentPage <= 2) {
    return null;
  }

  return /*#__PURE__*/React.createElement("a", _extends({
    "aria-label": "F\xF8rste resultatside"
  }, props, {
    ref: ref,
    className: classNames('button button--pill', className),
    rel: "start"
  }), _IconChevronDoubleLef || (_IconChevronDoubleLef = /*#__PURE__*/React.createElement(IconChevronDoubleLeft16, null)));
});
FirstPage.displayName = "FirstPage";

var _IconChevronRight;

var _excluded$4 = ["children", "className"];
var NextPage = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$children = _ref.children,
      children = _ref$children === void 0 ? 'Neste' : _ref$children,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4);

  var _usePagination = usePagination(),
      currentPage = _usePagination.currentPage,
      lastPage = _usePagination.lastPage;

  if (currentPage >= lastPage) {
    return null;
  }

  return /*#__PURE__*/React.createElement("a", _extends({
    "aria-label": "Neste resultatside"
  }, props, {
    ref: ref,
    rel: "next nofollow",
    className: classNames('button button--pill', className)
  }), currentPage <= 1 && /*#__PURE__*/React.createElement("span", {
    className: "button__text block md:hidden mr-8"
  }, children), _IconChevronRight || (_IconChevronRight = /*#__PURE__*/React.createElement(IconChevronRight16, null)));
});
NextPage.displayName = "NextPage";

var classes = {"paginationPage":"Page-module_paginationPage__FW5P5"};

var _excluded$3 = ["page", "className", "currentPage"];
var Page = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$page = _ref.page,
      page = _ref$page === void 0 ? 0 : _ref$page,
      className = _ref.className,
      currentPage = _ref.currentPage,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3);

  if (page < 1) {
    return null;
  }

  return /*#__PURE__*/React.createElement("a", _extends({
    "aria-label": "Side " + page
  }, props, {
    ref: ref,
    rel: "nofollow",
    "aria-current": page === currentPage ? 'page' : undefined,
    className: classNames(classes.paginationPage + " button button--pill", className)
  }), page);
});
Page.displayName = "Page";

var _excluded$2 = ["children", "className"];
var Pages = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2);

  var _usePagination = usePagination(),
      currentPage = _usePagination.currentPage,
      lastPage = _usePagination.lastPage;

  var from = Math.max(currentPage - 3, 0);
  var to = Math.min(from + 7, lastPage);
  var pages = Array.from(Array(to - from).keys()).map(function (_, i) {
    return from + i + 1;
  });
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: classNames('hidden md:block', className),
    ref: ref
  }), pages.map(function (page) {
    return /*#__PURE__*/React.cloneElement(children(page), {
      key: page,
      page: page,
      currentPage: currentPage
    });
  }));
});
Pages.displayName = "Pages";

var _IconChevronLeft;

var _excluded$1 = ["className"];
var PrevPage = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1);

  var _usePagination = usePagination(),
      currentPage = _usePagination.currentPage;

  if (currentPage <= 1) {
    return null;
  }

  return /*#__PURE__*/React.createElement("a", _extends({
    "aria-label": "Forrige resultatside"
  }, props, {
    ref: ref,
    className: classNames('button button--pill', className),
    rel: "prev nofollow"
  }), _IconChevronLeft || (_IconChevronLeft = /*#__PURE__*/React.createElement(IconChevronLeft16, null)));
});
PrevPage.displayName = "PrevPage";

var _CurrentPage;

var _excluded = ["currentPage", "lastPage", "createHref", "className", "onChange"];
var Pagination = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var currentPage = _ref.currentPage,
      lastPage = _ref.lastPage,
      createHref = _ref.createHref,
      className = _ref.className,
      onChange = _ref.onChange,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  if (!createHref) {
    throw new TypeError('createHref is undefined');
  }

  var handleClick = function handleClick(page) {
    return function (event) {
      if (onChange) {
        event.preventDefault();
        onChange(page);
      }
    };
  };

  return /*#__PURE__*/React.createElement(PaginationContainer, _extends({}, props, {
    ref: ref,
    currentPage: currentPage,
    lastPage: lastPage,
    className: className
  }), /*#__PURE__*/React.createElement(FirstPage, {
    href: createHref(1),
    onClick: handleClick(1)
  }), /*#__PURE__*/React.createElement(PrevPage, {
    href: createHref(currentPage - 1),
    onClick: handleClick(currentPage - 1)
  }), /*#__PURE__*/React.createElement(Pages, null, function (page) {
    return /*#__PURE__*/React.createElement(Page, {
      href: createHref(page),
      onClick: handleClick(page)
    });
  }), _CurrentPage || (_CurrentPage = /*#__PURE__*/React.createElement(CurrentPage, null)), /*#__PURE__*/React.createElement(NextPage, {
    href: createHref(currentPage + 1),
    onClick: handleClick(currentPage + 1)
  }));
});
Pagination.displayName = "Pagination";

export { CurrentPage, FirstPage, NextPage, Page, Pages, Pagination, PaginationContainer, PrevPage, usePagination };
//# sourceMappingURL=index.es.js.map
